import * as keys from "../enums/QueryKeys";
import { CLINIC_DTO, CLINIC_PERMISSIONS, CLINICS } from "../enums/ApiPaths";
import { useFetch } from "./Fetching";

export function useGetClinics() {
  const url = CLINICS;
  const { data, isLoading, error } = useFetch(
    CLINICS,
    null,
    keys.CLINICS_MASTER
  );

  return { data, isLoading, error };
}

export function useGetSingleClinic(clinciId) {
  const { data, isLoading, error } = useFetch(
    CLINIC_DTO,
    clinciId,
    keys.CLINICS + clinciId
  );

  return { data, isLoading, error };
}

// Permissions granted by the clinic's tier - what the clinic itself can see.
// Master has no clinic of their own, so this is how master-facing views
// mirror the clinic's tier instead of showing every feature.
export function useGetClinicPermissions(clinicId, isEnabled = true) {
  const { data, isLoading, error } = useFetch(
    CLINIC_PERMISSIONS,
    clinicId,
    [keys.CLINICS + clinicId, keys.PERMISSIONS],
    isEnabled && Boolean(clinicId)
  );

  return { data: data ?? [], isLoading, error };
}
